<template>
<Modal v-model="model" sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide :mask="false" draggable class="public_double_pop" :style="{left: '15%'}" width="1200">
    <Spin size="small" fix v-if="spinShow">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>正在加载中...</div>
    </Spin>
    <div class="public_input">
        <div class="input_style">
            <div class="font_style_set"><span class="span_must">*</span>技能组名称:</div>
            <Input v-model="queueName" placeholder="请输入技能组名称" />
        </div>
        <div class="input_style">
            <div class="font_style_set"><span class="span_must">*</span>技能组号码:</div>
            <Input v-model="queuePhone" placeholder="请输入技能组号码" />
        </div>
    </div>
    <!--AI 流程 及 最大线数-->
    <div class="public_input" v-show="aiQueue">
        <div class="input_style">
            <div class="font_style_set"><span class="span_must">*</span>AI流程:</div>
            <Select v-model="rwId">
                <Option v-for="(option,index) in aiFlow" :value="option.id+''" :key="index">{{option.rwName}}</Option>
            </Select>
        </div>
        <div class="input_style">
            <div class="font_style_set"><span class="span_must">*</span>最大并发数:</div>
            <Input v-model="robotNum" type="number" @input.native="formatNum($event)" class="config_content" :placeholder="`企业最大机器人数：`+companyMaxLines" title="最大并发数" />
        </div>
    </div>
    <div class="public_input">
        <div class="input_style">
            <div class="font_style_set">客户等待时播报方式:</div>
            <Select v-model="flagPlayOrder"  @click.native="selectfnA()" placeholder="请选择客户等待时播报方式" :class="{'react_chain':flagPlayOrder!='0' && flagPlayOrder!='1'}">
            	<Option v-for="(option, index) in waitStyleList" :hidden="option.is_true==1?true:false"   :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
            <Select v-model="userDefineMusicId" class="react_chain" v-if="flagPlayOrder!='0' && flagPlayOrder!='1'">
                <Option v-for="(option, index) in queueMusicList" :value="option.id" :key="index">{{option.musicName}}</Option>
            </Select>
        </div>
        <div class="input_style">
            <div class="font_style_set"><span class="span_must">*</span>播报间隔时长(秒):</div>
            <Input v-model="firstWaitTime" style="width: 30%" :disabled="flagPlayOrder=='0'" placeholder="请输入首次等待时长(秒)" title="首次等待时长(秒)" @on-blur="checkNumber" />
            <Input v-model="playOrderPeriod" style="width: 30%" :disabled="flagPlayOrder=='0'" placeholder="请输入持续等待时长(秒)" title="持续等待时长(秒)" @on-blur="checkNumber" />
        </div>
    </div>
    <div class="public_input" v-show="!aiQueue">
        <div class="input_style">
            <div class="font_style_set">座席振铃时长(秒):</div>
            <Select v-model="maxNoAnswerTime" placeholder="请选择座席振铃时长">
                <Option v-for="(option, index) in timeList" :value="option.value" :key="index">{{option.value}}</Option>
            </Select>
        </div>
        <div class="input_style">
            <div class="font_style_set">保留的最少空闲座席数:</div>
            <Input v-model="minReserveAgent" placeholder="请输入最少空闲座席数" />
        </div>
    </div>
    <div class="public_input">
        <div class="input_style">
            <div class="font_style_set">最大等待时长(秒):</div>
            <Input v-model="maxWaitTime" placeholder="请输入最大等待时长" />
        </div>
        <div class="input_style">
            <div class="font_style_set"><span class="span_must">*</span>超过最大等待时长之后:</div>
            <Select v-model="maxWaitTimeReached"  :class="{'react_chain':maxWaitTimeReached=='1' || maxWaitTimeReached=='2' || maxWaitTimeReached=='4'}" @click.native="selectfnB()" placeholder="请选择座席振铃时长" @on-change="handleInput('1')">
               <Option  v-for="(option, index) in publicList" :hidden="option.is_true==1?true:false" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
            <Input v-model="maxWaitTimeReachedValue1" v-if="maxWaitTimeReached=='4'" class="react_chain" placeholder="请输入号码" />
            <Select v-model="maxWaitTimeReachedValue1" v-if="maxWaitTimeReached=='1'" class="react_chain" placeholder="请选择IVR">
                <Option v-for="(option, index) in ivrList" :value="option.ivrId" :key="index">{{option.ivrName}}</Option>
            </Select>
            <Select v-model="maxWaitTimeReachedValue1" v-if="maxWaitTimeReached=='2'" class="react_chain" placeholder="请选择技能组号码">
                <OptionGroup label="普通技能组">
                    <Option v-for="(option, index) in queueList" :value="option.id" :key="`normal`+index">{{option.queueName}}</Option>
                </OptionGroup>
<!--                <OptionGroup label="AI技能组">-->
<!--                    <Option v-for="(option, index) in queueList2" :value="option.queueNum" :key="`ai`+index">{{option.queueName}}</Option>-->
<!--                </OptionGroup>-->
            </Select>
        </div>
    </div>
    <div class="public_input" v-show="!aiQueue">
        <div class="input_style">
            <div class="font_style_set">最大排队人数:</div>
            <Input v-if="companyType=='1'" v-model="maxWaitPeople" placeholder="请输入最大排队人数" />
            <Input v-if="companyType=='0'" v-model="maxWaitPeople_dx" placeholder="请输入最大排队人数" :disabled="disabled" />
        </div>
        <div class="input_style">
            <div class="font_style_set"><span class="span_must">*</span>超过最大排队人数之后:</div>
            <Select v-model="maxWaitPeopleReached"  :class="{'react_chain':maxWaitPeopleReached=='1' || maxWaitPeopleReached=='2' || maxWaitPeopleReached=='4'}" @click.native="selectfnC()" placeholder="请选择座席振铃时长" @on-change="handleInput('2')">
                 <Option  v-for="(option, index) in publicListA" :hidden="option.is_true==1?true:false" :value="option.id" :key="index">{{option.name}}</Option>
	        </Select>
            <Input v-model="maxWaitPeopleReachedValue1" v-if="maxWaitPeopleReached=='4'" class="react_chain" placeholder="请输入号码" />
            <Select v-model="maxWaitPeopleReachedValue1" v-if="maxWaitPeopleReached=='1'" class="react_chain" placeholder="请选择IVR">
                <Option v-for="(option, index) in ivrList" :value="option.ivrId" :key="index">{{option.ivrName}}</Option>
            </Select>
            <Select v-model="maxWaitPeopleReachedValue1" v-if="maxWaitPeopleReached=='2'" class="react_chain" placeholder="请选择技能组号码">
                <OptionGroup label="普通技能组">
                    <Option v-for="(option, index) in queueList" :value="option.id" :key="`normal`+index">{{option.queueName}}</Option>
                </OptionGroup>
<!--                <OptionGroup label="AI技能组">-->
<!--                    <Option v-for="(option, index) in queueList2" :value="option.queueNum" :key="`ai`+index">{{option.queueName}}</Option>-->
<!--                </OptionGroup>-->
            </Select>
        </div>
    </div>
    <div class="public_input" v-show="!aiQueue">
        <div class="input_style">
            <div class="font_style_set">无座席时最大等待时长(秒):</div>
            <Input v-model="maxWaitTimeNoagent" placeholder="请输入无座席时最大等待时长" />
        </div>
        <div class="input_style">
            <div class="font_style_set"><span class="span_must">*</span>无座席等待超时后:</div>
            <Select v-model="maxWaitTimeNoagentReached"   :class="{'react_chain':maxWaitTimeNoagentReached=='1' || maxWaitTimeNoagentReached=='2' || maxWaitTimeNoagentReached=='4'}" @click.native="selectfnD()" placeholder="请选择座席振铃时长" @on-change="handleInput('3')">
                <Option  v-for="(option, index) in publicListB" :hidden="option.is_true==1?true:false" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
            <Input v-model="maxWaitTimeNoagentReachedValue1" v-if="maxWaitTimeNoagentReached=='4'" class="react_chain" placeholder="请输入号码" />
            <Select v-model="maxWaitTimeNoagentReachedValue1" v-if="maxWaitTimeNoagentReached=='1'" class="react_chain" placeholder="请选择IVR">
                <Option v-for="(option, index) in ivrList" :value="option.ivrId" :key="index">{{option.ivrName}}</Option>
            </Select>
            <Select v-model="maxWaitTimeNoagentReachedValue1" v-if="maxWaitTimeNoagentReached=='2'" class="react_chain" placeholder="请选择技能组号码">
                <OptionGroup label="普通技能组">
                    <Option v-for="(option, index) in queueList" :value="option.id" :key="`normal`+index">{{option.queueName}}</Option>
                </OptionGroup>
<!--                <OptionGroup label="AI技能组">-->
<!--                    <Option v-for="(option, index) in queueList2" :value="option.queueNum" :key="`ai`+index">{{option.queueName}}</Option>-->
<!--                </OptionGroup>-->
            </Select>
        </div>
    </div>
    <div class="public_input" v-show="!aiQueue && companyType!='0'">
        <div class="input_style">
            <div class="font_style_set">是否启用VIP:</div>
          <RadioGroup v-model="vipSwitch" type="button" placeholder="请选择是否启用VIP">
            <Radio v-for="(option, index) in isEnable" :label="option.id" :key="index">{{option.name}}</Radio>
          </RadioGroup>
        </div>
        <div class="input_style">
            <div class="font_style_set">VIP判断方法:</div>
            <Select v-model="vipJudgeType " placeholder="请选择VIP判断方法" :disabled="vipSwitch=='0'">
                <Option v-for="(option, index) in VIPList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
        </div>
    </div>
    <div class="public_input" v-show="!aiQueue && companyType!='0'">
        <div class="input_style">
            <div class="font_style_set">判断是否为VIP的http地址:</div>
            <Input v-model="vipHttpUrl" placeholder="请输入判断是否为VIP的http地址" :disabled="vipJudgeType=='0' || vipSwitch=='0'" />
        </div>
        <div class="input_style">
            <div class="font_style_set">http请求的超时时间(秒):</div>
            <Input v-model="vipHttpTimeout" placeholder="请输入http请求的超时时间" :disabled="vipJudgeType=='0' || vipSwitch=='0'" />
        </div>
    </div>
    <div class="public_input" v-show="!aiQueue">
        <div class="input_style">
            <div class="font_style_set">是否启用专属座席:</div>
          <RadioGroup v-model="exclusiveSwitch" type="button" placeholder="请选择是否启用专属座席">
            <Radio v-for="(option, index) in isEnable" :label="option.id" :key="index">{{option.name}}</Radio>
          </RadioGroup>
        </div>
        <div class="input_style">
            <div class="font_style_set">判断专属座席http地址:</div>
            <Input v-model="exclusiveHttpUrl" :disabled="exclusiveSwitch=='0'" placeholder="请输入判断专属座席http地址" style="width: 55%;" />
            <Tooltip class="tips_font" placement="top" content="示例：http://127.0.0.1/mpccApi/api/exclusiveAgent.json?caller={caller}&callee={callee}&queue_num={queue_num}&companyid={companyid}"><img :src="questionMark" /></Tooltip>
        </div>
    </div>
    <div class="public_input" v-show="!aiQueue">
        <div class="input_style">
            <div class="font_style_set">技能组背景音:</div>
            <Select v-model="queueMusicId" placeholder="请选择技能组背景音" clearable>
                <Option v-for="(option, index) in queueMusicList" :value="option.id" :key="index">{{option.musicName}}</Option>
            </Select>
        </div>
        <div class="input_style">
            <div class="font_style_set">接通时播报工号:</div>
            <Select v-model="flagPlayAgentnum" placeholder="请选择是否播报工号" @click.native="selectfnE()">
                <Option v-for="(option, index) in playList" :hidden="option.is_true==1?true:false" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
        </div>
    </div>
    <div class="public_input" v-show="!aiQueue">
        <div class="input_style">
            <div class="font_style_set">非唯一算法:</div>
            <Select v-model="manyStrategy" v-if="companyType=='1'" style="height:27px !important;" multiple placeholder="请选择非唯一算法" clearable>
                 <Option  v-for="(option, index) in multipleList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
            <Select v-if="companyType=='0'" v-model="manyStrategy" multiple placeholder="请选择非唯一算法" clearable>
                 <Option v-for="(option, index) in multipleListB" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
        </div>
        <div class="input_style">
            <div class="font_style_set"><span class="span_must">*</span>唯一算法:</div>
            <Select v-model="queueStrategy" style="width: 55%;">
                <Option v-for="(option, index) in onlyList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
            <Tooltip class="tips_font" placement="top">
              <div slot="content">
                <p>最少应答次数分配: 呼入通话优先分配给技能组中应答次数最少的员工，相同应答次数随机分配（员工应答次数指员工接通，包括员工呼出接通和呼入员工接通）</p>
                <p>座席登录顺序分配: 呼入通话按技能组中员工的签入顺序进行呼叫，座席签出超过5分钟后重新签入会刷新该座席顺序为末尾</p>
                <p>最长闲时分配: 呼入通话优先分配给技能组中当前空闲持续时间最长的座席（仅判断当前空闲时长，与员工总空闲时长无关）</p>
                <p>随机分配: 呼入通话随机分配给技能组中空闲座席</p>
                <p>记忆轮询: 呼入通话按技能组中员工的签入顺序进行呼叫，座席重新签入后会刷新该座席顺序为末尾。每次进入记忆轮循流程时将从上一次被振铃员工顺序后的员工开始呼叫</p>
              </div>
              <img :src="questionMark" />
            </Tooltip>
        </div>
    </div>
    <div class="btn_template" style="margin-top:15px">
        <Button type="error" class="cancel_btn" @click="cancel()">取消</Button>
        <Button type="primary" class="submit_btn" @click="save()">保存</Button>
    </div>
</Modal>
</template>

<script>
import {
    publicFunClass
} from '@/components/js/PublicFunClass.js'
export default {
    name: "SkillsGroupEditPop",
    mixins: [publicFunClass],
    props: {
        showSkillsGroupEdit: Boolean,
        title: String,
        skillId: String,
        aiQueue: {
            type: Boolean,
            default: false
        },
        lines: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            questionMark: require('../../../assets/image/homeAsk.png'),
            model: false,
            spinShow: true,
            ivrList: [],
            queueList: [],
            queueList2: [],
            queueMusicList: [],
            multipleList: [{
                'id': '1',
                'name': '区域优先'
            }, {
                'id': '2',
                'name': '上次服务座席优先'
            }, {
                'id': '3',
                'name': '技能等级最高优先'
            }],
	    multipleListB: [{
                'id': '2',
                'name': '上次服务座席优先'
            }],
            manyStrategy: [],
            onlyList: [{
                'id': '4',
                'name': '座席登录顺序分配'
            }, {
                'id': '5',
                'name': '随机分配'
            }, {
                'id': '6',
                'name': '最少应答次数分配'
            }, {
                'id': '7',
                'name': '最长闲时分配'
            }, {
              'id': '8',
              'name': '记忆轮循'
            }],
            playList: [{
                'is_true': '0',
                'id': '0',
                'name': '不播报'
            }, {
                'is_true': '0',
                'id': '1',
                'name': '报工号'
            },{
                'is_true': '0',
              'id': '2',
              'name': '报工号(含转接)'
	        }],
            isEnable: [{
                'id': '0',
                'name': '不启用'
            }, {
                'id': '1',
                'name': '启用'
            }],
            VIPList: [{
                'id': '0',
                'name': '使用CTI的VIP判断方法'
            }, {
                'id': '1',
                'name': '使用CRM的VIP判断方法'
            }],
            timeList: [{
                'value': '5'
            }, {
                'value': '10'
            }, {
                'value': '15'
            }, {
                'value': '20'
            }, {
                'value': '25'
            }, {
                'value': '30'
            }, {
                'value': '35'
            }, {
                'value': '40'
            }, {
                'value': '45'
            }, {
                'value': '50'
            }, {
                'value': '55'
            }, {
                'value': '60'
            }],
            waitStyleList: [{
                'is_true': '0',
                'id': '0',
                'name': '不播报'
            }, {
                'is_true': '0',
                'id': '1',
                'name': '排队位置'
            }, {
                'is_true': '0',
                'id': '2',
                'name': '自定义语音'
            }, {
                'is_true': '0',
                'id': '3',
                'name': '继续等待'
            }, {
                'is_true': '0',
                'id': '4',
                'name': '等待及留言'
            }],
            publicList: [{
                'is_true': '0',
                'id': '0',
                'name': '挂断'
            }, {
                'is_true': '0',
                'id': '1',
                'name': '转IVR'
            }, {
                'is_true': '0',
                'id': '2',
                'name': '转技能组'
            }, {
                'is_true': '0',
                'id': '3',
                'name': '转语音信箱'
            }, {
                'is_true': '0',
                'id': '4',
                'name': '转号码'
            }],
	        publicListA: [{
                 'is_true': '0',
                'id': '0',
                'name': '挂断'
            }, {
                'is_true': '0',
                'id': '1',
                'name': '转IVR'
            }, {
                 'is_true': '0',
                'id': '2',
                'name': '转技能组'
            }, {
                 'is_true': '0',
                'id': '3',
                'name': '转语音信箱'
            }, {
                 'is_true': '0',
                'id': '4',
                'name': '转号码'
            }],
            publicListB: [{
                 'is_true': '0',
                'id': '0',
                'name': '挂断'
            }, {
                 'is_true': '0',
                'id': '1',
                'name': '转IVR'
            }, {
                'is_true': '0',
                'id': '2',
                'name': '转技能组'
            }, {
                'is_true': '0',
                'id': '3',
                'name': '转语音信箱'
            }, {
                'is_true': '0',
                'id': '4',
                'name': '转号码'
            }],
            maxWaitTime: '180',
            maxWaitTimeReached: '3',
            maxWaitTimeReachedValue1: '',
            maxWaitPeople:'0',
            maxWaitPeople_dx:'1',
            maxWaitPeopleReached: '3',
            maxWaitPeopleReachedValue1: '',
            maxWaitTimeNoagent: '60',
            maxWaitTimeNoagentReached: '3',
            maxWaitTimeNoagentReachedValue1: '',
            minReserveAgent: '0',
            flagPlayAgentnum: '0',
            flagPlayOrder: '0',
            userDefineMusicId: '',
            queuePhone: "",
            queueName: '',
            queueMusicId: '',
            firstWaitTime: '30',
            playOrderPeriod: '30',
            maxNoAnswerTime: '10',
            vipSwitch: '0',
            vipJudgeType: '0',
            vipHttpUrl: '',
            vipHttpTimeout: '5',
            exclusiveSwitch: '0',
            exclusiveHttpUrl: 'http://127.0.0.1/mpccApi/api/exclusiveAgent.json?caller={caller}&callee={callee}&queue_num={queue_num}&companyid={companyid}',
            queueStrategy: '8',
            rwId: '',
            aiFlow: [],
            companyMaxLines: '0',
            robotNum: '',
            editOrAdd: false,
            companyType:localStorage.getItem("companyType"),
            disabled:true,
        }
    },
    methods: {
        checkNumber: function (event) {
            let name = event.currentTarget.name;
            let value = event.currentTarget.value;
            let reg = /^[0-9]*$/;
            if (!reg.test(value)) {
                this.$Modal.info({
                    title: '提示',
                    content: name + "只能输入数字"
                });
                event.currentTarget.value = event.currentTarget.value.replace(/[^\d]/g, '');
                return false;
            }
            let firstWaitTime = parseInt(this.firstWaitTime);
            let playOrderPeriod = parseInt(this.playOrderPeriod);
            if (firstWaitTime <= 1) {
                this.firstWaitTime = "1";
            }
            if (playOrderPeriod <= 7) {
                this.playOrderPeriod = "7";
            }
        },
        formatNum(e) {
            let value = e.target.value
            if (value.length === 1) {
                e.target.value = value.replace(/[^0-9]/g, '');
            } else {
                if (value < 0) {
                    e.target.value = 0;
                } else {
                    value = value.replace(/\D/g, '');
                    if (value > this.companyMaxLines) {
                        e.target.value = this.companyMaxLines;
                    } else {
                        e.target.value = value
                    }
                }
            }
            if (value > this.companyMaxLines) {
                e.target.value = this.companyMaxLines
            }
            this.robotNum = e.target.value
        },
        handleInput: function (sign) {
            if (sign == '1') {
                this.maxWaitTimeReachedValue1 = "";
                if (this.maxWaitTimeReached == '1' && this.ivrList[0]) {
                    this.maxWaitTimeReachedValue1 = this.ivrList[0].ivrId;
                }
                if (this.maxWaitTimeReached == '2' && this.queueList[0]) {
                    this.maxWaitTimeReachedValue1 = this.queueList[0].id;
                }
            }
            if (sign == '2') {
                this.maxWaitPeopleReachedValue1 = "";
                if (this.maxWaitPeopleReached == '1' && this.ivrList[0]) {
                    this.maxWaitPeopleReachedValue1 = this.ivrList[0].ivrId;
                }
                if (this.maxWaitPeopleReached == '2' && this.queueList[0]) {
                    this.maxWaitPeopleReachedValue1 = this.queueList[0].id;
                }
            }
            if (sign == '3') {
                this.maxWaitTimeNoagentReachedValue1 = "";
                if (this.maxWaitTimeNoagentReached == '1' && this.ivrList[0]) {
                    this.maxWaitTimeNoagentReachedValue1 = this.ivrList[0].ivrId;
                }
                if (this.maxWaitTimeNoagentReached == '2' && this.queueList[0]) {
                    this.maxWaitTimeNoagentReachedValue1 = this.queueList[0].id;
                }
            }
        },
        cancel: function () {
            this.$emit("closeSkillsGroup", false);
        },
        selectfnA: function () {//客户等待时播报方式
            if(this.companyType=='0'){
                this.waitStyleList= [{ 'is_true': '0','id': '0','name': '不播报'},{'is_true': '1','id': '1','name': '排队位置'},{'is_true': '0','id': '2','name': '自定义语音'}, {'is_true': '0','id': '3', 'name': '继续等待'}, { 'is_true': '0','id': '4','name': '等待及留言'}]
            }
        },
        selectfnB: function () {//超过最大等待时长之后
             if(this.companyType=='0'){
                    this.publicList=[{'is_true': '0','id': '0','name': '挂断'},{'is_true': '1','id': '1','name': '转IVR'}, {'is_true': '1','id': '2','name': '转技能组'}, {'is_true': '0','id': '3','name': '转语音信箱'}, {'is_true': '0','id': '4','name': '转号码'}]
            }
        },
        selectfnC: function () { //超过最大排队人数之后
                if(this.companyType=='0'){
                    this.publicListA=[{'is_true': '0','id': '0','name': '挂断'},{'is_true': '1','id': '1','name': '转IVR'}, {'is_true': '1','id': '2','name': '转技能组'}, {'is_true': '0','id': '3','name': '转语音信箱'}, {'is_true': '0','id': '4','name': '转号码'}]
                }
        },
        selectfnD: function () { //无座席等待超时后
                 if(this.companyType=='0'){
                    this.publicListB=[{'is_true': '0','id': '0','name': '挂断'},{'is_true': '1','id': '1','name': '转IVR'}, {'is_true': '1','id': '2','name': '转技能组'}, {'is_true': '0','id': '3','name': '转语音信箱'}, {'is_true': '0','id': '4','name': '转号码'}]
                }
        },
        selectfnE: function () {//接通时播报工号
            if(this.companyType=='0'){
                this.playList=[{'is_true': '0','id': '0','name': '不播报'},{'is_true': '1','id': '1','name': '报工号'},{'is_true': '1','id': '2','name': '报工号(含转接)'}]
            }
        },
      save: function () {
        if (!this.aiQueue) {
          if (!this.queueStrategy) {
            this.$Message.info('唯一算法必填')
            return false
          }
        }
        if (this.aiQueue) {
          if (!this.rwId) {
            this.$Message.info('AI流程必选')
            return false
          }
          if (!this.robotNum || this.robotNum <= 0) {
            this.$Message.info('最大并发线数必须大于0')
            return false
          }
        }

        let numReg = /^[0-9]*$/
        let numRe = new RegExp(numReg)
        if (!this.queuePhone) {
          this.$Message.info('技能组号码必填')
          return false
        } else {
          if (!numRe.test(this.queuePhone)) {
            this.$Message.info('技能组号码格式错误')
            return false
          }
        }
        if (!this.queueName) {
          this.$Message.info('技能组名称必填')
          return false
        }
        if (!this.maxWaitTimeReached) {
          this.$Message.info('超过最大等待时长之后必选')
          return false
        }
        if (!this.maxWaitTimeNoagentReached) {
          this.$Message.info('无座席等待超时后必选')
          return false
        }
         if (!this.maxWaitPeopleReached) {
          this.$Message.info('超过最大排队人数之后必选')
          return false
        }
        if (this.firstWaitTime) {
          if (!numRe.test(this.firstWaitTime)) {
            this.$Message.info('首次等待时长格式错误')
            return false
          }
        }
        if (this.playOrderPeriod) {
          if (!numRe.test(this.playOrderPeriod)) {
            this.$Message.info('持续等待时长格式错误')
            return false
          }
        }
        if (!this.aiQueue) {
          if (this.minReserveAgent) {
            if (!numRe.test(this.minReserveAgent)) {
              this.$Message.info('最少空闲座席数格式错误')
              return false
            }
          }
        }

        if (this.maxWaitTime) {
          if (!numRe.test(this.maxWaitTime)) {
            this.$Message.info('最大等待时长格式错误')
            return false
          }
        }
        if (this.maxWaitTimeReachedValue1) {
          if (!numRe.test(this.maxWaitTimeReachedValue1)) {
            this.$Message.info('号码格式错误')
            return false
          }
        }
        if (this.maxWaitPeople) {
          if (!numRe.test(this.maxWaitPeople)) {
            this.$Message.info('最大排队人数格式错误')
            return false
          }
        }
        if (this.maxWaitPeople_dx) {
          if (!numRe.test(this.maxWaitPeople_dx)) {
            this.$Message.info('最大排队人数格式错误')
            return false
          }
        }
        if (!this.aiQueue) {
          if (this.maxWaitTimeNoagent) {
            if (!numRe.test(this.maxWaitTimeNoagent)) {
              this.$Message.info('无座席时最大等待时长格式错误')
              return false
            }
          }
          if (this.vipHttpTimeout) {
            if (!numRe.test(this.vipHttpTimeout)) {
              this.$Message.info('http请求的超时时间格式错误')
              return false
            }
          }
        } else {
          this.maxWaitTimeNoagent = '0'
        }
        let manyStrategy = ''
        if (this.manyStrategy.length != 0) {
          manyStrategy = this.manyStrategy.toString()
        }
        let journalType = '系统管理=>CTI配置=>添加技能组'
        let menuId = '3_5-2-1'
        if (this.aiQueue) {
          journalType = 'AI机器人管理=>AI技能组管理=>添加技能组'
          menuId = 'a_4-1'
        }
        if (this.skillId) {
          journalType = '系统管理=>CTI配置=>编辑技能组'
          menuId = '3_5-2-2'
          if (this.aiQueue) {
            journalType = 'AI机器人管理=>AI技能组管理=>编辑技能组'
            menuId = 'a_4-2'
          }
        }
        let queueMusicId = this.queueMusicId
        if (!this.queueMusicId) {
          queueMusicId = ''
        }
        let queueType = '0'
        if (this.aiQueue) {
          queueType = '1'
        }
        let commaxpeople;
        if(this.companyType=="1"){
            commaxpeople=this.maxWaitPeople;
        }else if(this.companyType=="0"){
            commaxpeople=this.maxWaitPeople_dx;
        }
        let param = {
          id: this.skillId,
          maxWaitTime: this.maxWaitTime,
          maxWaitTimeReached: this.maxWaitTimeReached,
          maxWaitTimeReachedValue: this.maxWaitTimeReachedValue1,
         // maxWaitPeople: this.maxWaitPeople,
          maxWaitPeople:commaxpeople,
          maxWaitPeopleReached: this.maxWaitPeopleReached,
          maxWaitPeopleReachedValue: this.maxWaitPeopleReachedValue1,
          maxWaitTimeNoagent: this.maxWaitTimeNoagent,
          maxWaitTimeNoagentReached: this.maxWaitTimeNoagentReached,
          maxWaitTimeNoagentReachedValue: this.maxWaitTimeNoagentReachedValue1,
          minReserveAgent: this.minReserveAgent,
          flagPlayAgentnum: this.flagPlayAgentnum,
          flagPlayOrder: this.flagPlayOrder,
          queuePhone: this.queuePhone,
          queueName: this.queueName,
          queueMusicId: queueMusicId,
          firstWaitTime: this.firstWaitTime,
          playOrderPeriod: this.playOrderPeriod,
          maxNoAnswerTime: this.maxNoAnswerTime,
          vipSwitch: this.vipSwitch,
          vipJudgeType: this.vipJudgeType,
          vipHttpUrl: this.vipHttpUrl,
          vipHttpTimeout: this.vipHttpTimeout,
          exclusiveSwitch: this.exclusiveSwitch,
          exclusiveHttpUrl: this.exclusiveHttpUrl,
          manyStrategy: manyStrategy,
          queueStrategy: this.queueStrategy,
          transferLate: '10',
          queueType: queueType,
          rwId: this.rwId,
          robotNum: this.robotNum,
          userDefineMusicId: this.userDefineMusicId,
          journalType: journalType,
          menuId: menuId
        }

        let that = this
        this.$http.post('skillGroup/doSave.json', param).then(function (res) {
          let result = res.data.flag
          if (result != '666') {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            })
            return false
          }
          that.$Message.info('技能组保存成功')
          that.$emit('closeSkillsGroup', true)
        })
      },
        init: function () {
            let that = this;
            let param = {
                id: this.skillId,
                journalType: "null",
                menuId: "null"
            };
            this.spinShow = true;
            this.$http.post("skillGroup/doSelectOne.json", param).then(function (res) {
                let result = res.data.flag;
                that.spinShow = false;
                if (result != "666") {
                    that.$alert(res.data.msg, '提示', {
                        confirmButtonText: '确定'
                    });
                    return false;
                }
                let object = res.data.obj.content;
                that.queueMusicList = res.data.obj.custMusicList;
                that.ivrList = res.data.obj.ivrList;
                if (!object) {
                    return false;
                }
                that.maxWaitTimeReached = object.maxWaitTimeReached;
                that.maxWaitTime = object.maxWaitTime;
                that.maxWaitTimeReachedValue1 = object.maxWaitTimeReachedValue;
                that.maxWaitPeople = object.maxWaitPeople;
                that.maxWaitPeopleReached = object.maxWaitPeopleReached;
                that.maxWaitPeopleReachedValue1 = object.maxWaitPeopleReachedValue;
                that.maxWaitTimeNoagent = object.maxWaitTimeNoagent;
                that.maxWaitTimeNoagentReached = object.maxWaitTimeNoagentReached;
                that.maxWaitTimeNoagentReachedValue1 = object.maxWaitTimeNoagentReachedValue;
                that.minReserveAgent = object.minReserveAgent;
                that.flagPlayAgentnum = object.flagPlayAgentnum;
                that.flagPlayOrder = object.flagPlayOrder;
                that.queuePhone = object.queuenum;
                that.queueName = object.queuename;
                that.queueMusicId = object.queueMusicId;
                that.firstWaitTime = object.firstWaitTime;
                that.playOrderPeriod = object.playOrderPeriod;
                that.maxNoAnswerTime = object.maxNoanswerTime;
                that.vipSwitch = object.vipSwitch;
                that.vipJudgeType = object.vipJudgeType;
                that.vipHttpUrl = object.vipHttpUrl;
                that.vipHttpTimeout = object.vipHttpTimeout;
                that.exclusiveSwitch = object.exclusiveSwitch;
                that.exclusiveHttpUrl = object.exclusiveHttpUrl;
                if (object.manyStrategy) {
                    that.manyStrategy = object.manyStrategy.split(",");
                }
                that.queueStrategy = object.queueStrategy;
                that.userDefineMusicId = res.data.obj.userDefineMusicId;
                that.rwId = object.rwId;
                that.robotNum = object.robotNum
                that.companyMaxLines = res.data.obj.maxLines
            });
        }
    },
    watch: {
        showSkillsGroupEdit: function () {
            this.model = this.showSkillsGroupEdit;
            this.companyMaxLines = this.lines
            if (this.showSkillsGroupEdit) {
                this.maxWaitTime = '180';
                this.maxWaitTimeReached = '3';
                this.maxWaitTimeReachedValue1 = '';
                this.maxWaitPeople = '0';
                this.maxWaitPeople_dx='1';
                this.maxWaitPeopleReached = '3';
                this.maxWaitPeopleReachedValue1 = '';
                this.maxWaitTimeNoagent = '60';
                this.maxWaitTimeNoagentReached = '3';
                this.maxWaitTimeNoagentReachedValue1 = '';
                this.minReserveAgent = '0';
                this.flagPlayAgentnum = '0';
                this.flagPlayOrder = '0';
                this.queuePhone = "";
                this.queueName = '';
                this.queueMusicId = '';
                this.firstWaitTime = '30';
                this.playOrderPeriod = '30';
                this.maxNoAnswerTime = '10';
                this.vipSwitch = '0';
                this.vipJudgeType = '0';
                this.vipHttpUrl = '';
                this.vipHttpTimeout = '5';
                this.exclusiveSwitch = '0';
                this.exclusiveHttpUrl = 'http://127.0.0.1/mpccApi/api/exclusiveAgent.json?caller={caller}&callee={callee}&queue_num={queue_num}&companyid={companyid}';
                this.manyStrategy = [];
                this.queueStrategy = '8';
                this.editOrAdd = false;
                let flag = false;
                if (this.skillId) {
                  flag = true;
                  this.editOrAdd = true;
                }
                this.getQueue('3',flag);
                this.init();
                if (this.aiQueue) {
                    this.getAIWorkFlow()
                    this.rwId = ''
                    this.robotNum = ''
                }
            }
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/CTIConfigure/SkillsGroupEditPop.vue